import type { ScreenLayoutKeyboardStickyProps } from "./types";

export const ScreenLayoutKeyboardSticky = ({ children }: ScreenLayoutKeyboardStickyProps) => (
  <>{children}</>
);

ScreenLayoutKeyboardSticky.displayName = "ScreenLayout.KeyboardSticky";
